var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 11,
    width: 40,
    height: 36,
    rx: 4,
    fill: "#A39090"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9V13",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 9V13",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 21,
    width: 34,
    height: 23,
    rx: 2,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 24.5554,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#6343E4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 24.5554,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#6343E4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 24.5554,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#6343E4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 24.5554,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#F26D6B"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 30.5554,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#6343E4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 36.5554,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#6343E4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 30.5554,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#6343E4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 36.5554,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#6343E4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30.5554,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#6343E4"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 36.5554,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#F26D6B"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 30.5554,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#F26D6B"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 36.5554,
    width: 4,
    height: 4,
    rx: 1,
    fill: "#F26D6B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.a405efbb1b7a4c88881ae1a857e0e6a4.svg";
export { ForwardRef as ReactComponent };